import React from 'react';
import Style from './index.css';

const MainImage = () => {
    return (
        <div className={Style.mainImage}>
            <img
                src="https://x0.ifengimg.com/ucms/2023_11/2510A68E860A6132752418D49BBD82E12C1A3157_size217_w1920_h520.jpg"
                alt="主图"
            />
        </div>
    );
};

export default MainImage;
